import { render, staticRenderFns } from "./RankList.vue?vue&type=template&id=2159f740&"
import script from "./RankList.vue?vue&type=script&lang=js&"
export * from "./RankList.vue?vue&type=script&lang=js&"
import style0 from "./RankList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2159f740')) {
      api.createRecord('2159f740', component.options)
    } else {
      api.reload('2159f740', component.options)
    }
    module.hot.accept("./RankList.vue?vue&type=template&id=2159f740&", function () {
      api.rerender('2159f740', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/GuideChildren/KpidataChildren/RankList.vue"
export default component.exports